<template>
  <div class="login">
      <!-- 售后客户服务   -->
      <div class="saleService">

        <div class="saleService_phone">
          <div class="saleService_img"><img src="~@/assets/images/phone.svg" alt=""></div>
          <span class="saleService_text">电话</span>
          <span class="saleService_text saleService_text_bottom">沟通</span>

          <div class="saleService_pop saleService_pop_phone">

            <div class="triangle"></div> 
            <div class="triangleX"></div>  
            
            <div class="saleService_pop_title">
              <img src="~@/assets/images/phone.svg" alt="">
              <span>CPS9.0售后经理</span>
            </div>
            <div class="saleService_pop_content">
              <span>刘经理 <a>18052468101</a></span>
              <span>赵经理 <a>13306169546</a></span>
            </div>
          </div>

        </div>

        <div class="saleService_wx">
          <div class="saleService_img"><img src="~@/assets/images/wx.svg" alt=""></div>
          <span class="saleService_text">微信</span>
          <span class="saleService_text saleService_text_bottom">咨询</span>

          <div class="saleService_pop saleService_pop_bg saleService_pop_wx">

            <div class="triangle"></div> 
            <div class="triangleX"></div>  

            <div class="saleService_pop_title saleService_pop_title_wx">
              <img src="~@/assets/images/wx.svg" alt="">
              <span>CPS9.0售后经理</span>
            </div>
            <div class="saleService_pop_content">
              <div class="saleService_pop_img">
                <img src="~@/assets/images/lxf.png" alt="">
                <span>刘经理</span>
              </div>
              <div class="saleService_pop_img">
                <img src="~@/assets/images/zyz.png" alt="">
                <span>赵经理</span>
              </div>
            </div>
          </div>
        </div>

      </div>

    <!--左侧背景图可配置-->
    <div class="left" :style="{backgroundImage: userSettings.loginImage? `url(${userSettings.loginImage})`: `url(${loginBg})`}">
      <!--标语可配置-->
      <div v-if="userSettings.loginSlogan">
        <div class="text" style="line-height: 1.2;padding: 16px 28px;">{{userSettings.loginSlogan}}</div>
      </div>
      <div v-else>
        <div class="text">打造最具价值工业互联APP</div>
        <div style="width: 80px; height: 8px; background: #fff; margin: 24px 0 8px"></div>
        <div class="text" style="font-size: 60px;">Count for more</div>
      </div>
    </div>
    <div class="right">
      <div class="right-prompt" v-if="showVersionPrompt">
        <a-alert :message="versionMsg" type="warning" show-icon />
      </div>
      <div class="header">
        <!--logo可配置-->
        <img v-if="userSettings.loginLogo" :src="userSettings.loginLogo">
        <img v-else src="~@/assets/images/login_logo.svg">
      </div>
      <div v-if="!isForget" class="body">
        <login-form :type="loginType"/>
        <a-divider style="font-size: 14px; color: rgba(0, 0, 0, 0.25)">
          <a @click.stop="onForget">
            {{loginType==='pwd' ?  getLang('page_login_login_by_phone'): getLang('page_login_login_by_pwd')}}
          </a>
        </a-divider>
      </div>
      <!--忘记密码模块  已废弃-->
      <!--<div v-if="isForget" class="body">
        <forget-form @onBack="onBack" />
      </div>-->
      <div class="footer">
        <div>Copyright &copy; 2021 无锡微茗智能科技有限公司</div>
        <div><a href="https://beian.miit.gov.cn" target="_blank">苏ICP备19005118号</a></div>
      </div>

    </div>
  </div>
</template>

<script>
import LoginForm from './components/LoginForm'
import { mapGetters } from 'vuex'
import loginBg from '@/assets/images/login_bg.png'
import { getLang } from './language/index.ts'
import { getPromptTime } from '@/utils/versionPrompt'
import dayjs from 'dayjs'

export default {
  name: 'Login',
  components: {
    LoginForm
  },
  data () {
    return {
      getLang,
      loginBg,
      isForget: false,
      bgStyle: {},
      showVersionPrompt: false,
      versionMsg: '',
      loginType: 'pwd' // 登录方式：{pwd: 账密登录，code：手机验证码登录}
    }
  },
  computed: {
    // 根据二级域名获取用户个性化设置
    ...mapGetters(['userSettings']),
  },
  async created(){
    const data = await getPromptTime()
    console.log(data)
    const now = dayjs().valueOf() // 获取当前时间
    const start = dayjs(data.start).valueOf()
    const end = dayjs(data.end).valueOf()
    if(start < now && now < end){
      this.showVersionPrompt = true
      this.versionMsg = data.message
    } else {
      this.showVersionPrompt = false
      this.versionMsg = ''
    }
  },
  methods: {
    onForget () {
      // this.isForget = true
      this.loginType = this.loginType === 'pwd' ? 'code' : 'pwd'
    },
    onBack () {
      this.isForget = false
    }
  }
}
</script>

<style lang="less" scoped>

  .saleService {
    position: absolute;
    width: 50px;
    height: 138px;
    right: 0;
    bottom: 80px;
    z-index: 99;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    
    .saleService_pop {
      width: 170px;
      height: 120px;
      position: absolute;
      border-radius: 3px;
      background-color: white;
      right: 75px;
      top: -20px;
      // overflow: hidden;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
      transition: all .2s ease;

      .triangle {
          position: absolute;
          right: -12px;
          top: 45%;
          width: 0;
          height: 0;
          border-top: 8px solid transparent;
          border-left: 12px solid white;
          border-bottom: 8px solid transparent;
          z-index: 10;
      }

      .triangleX {
        position: absolute;
        right: -7px;
        top: 48.7%;
        width: 12px;
        height: 8px;
        z-index: -1;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
      }

      .saleService_pop_title {
        width: 100%;
        height: 40px;
        background: -webkit-linear-gradient(rgb(129,195,242),rgb(76,146,226));
        background: -o-linear-gradient(rgb(129,195,242),rgb(76,146,226));
        background: -moz-linear-gradient(rgb(129,195,242),rgb(76,146,226));
        background: -mos-linear-gradient(rgb(129,195,242),rgb(76,146,226));
        background: linear-gradient(rgb(129,195,242),rgb(76,146,226));

        color: white;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;
        font-size: 14px;

        img {
          width: 20px;
          margin-right: 10px;
        }
      }

      .saleService_pop_title_wx {
        background: -webkit-linear-gradient(rgb(100,232,229),rgb(55,202,202));
        background: -o-linear-gradient(rgb(100,232,229),rgb(55,202,202));
        background: -moz-linear-gradient(rgb(100,232,229),rgb(55,202,202));
        background: -mos-linear-gradient(rgb(100,232,229),rgb(55,202,202));
        background: linear-gradient(rgb(100,232,229),rgb(55,202,202));
      }

      .saleService_pop_content {
        display: flex;
        flex-flow: column wrap;
        align-items: center;
        justify-content: center;
        height: 80px;

        span {
          display: inline-block;
          width: 100%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-size: 14px;
        }

        .saleService_pop_img {
          width: 50%;
          display: flex;
          flex-flow: column wrap;
          align-items: center;
          justify-content: center;

          img {
            width: 78%;
          }
        }
      }
    }

    .saleService_pop_bg {
      height: 150px;
      top: -40px;

      .saleService_pop_content {
        height: 110px;
        position: relative;
        padding-top: 6px;
      }

    }

    .saleService_phone {
      width: 100%;
      height: 50%;
      background-color: rgb(74, 144, 226);
      border-top-left-radius: 5px;
      position: relative;
      cursor: pointer;
    }

    .saleService_wx {
      width: 100%;
      height: 50%;
      background-color: rgb(54, 207, 201);
      border-bottom-left-radius: 5px;
      position: relative;
      cursor: pointer;
    }

    .saleService_img {
        width: 100%;
        height: 30px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;

        img {
          width: 24px;
          position: relative;
          top: 4px;
        }
      }

      .saleService_text {
        color: white;
        display: inline-block;
        width: 100%;
        height: 18px;
        line-height: 18px;
        text-align: center;
        font-size: 12px;
        transform: scale(0.95);
        position: relative;
        top: -2px;
      }

      .saleService_text_bottom {
        position: relative;
        top: -10px;
      }

      .saleService_pop_phone {
        opacity: 0;
        display: none;
      }

      .saleService_pop_wx {
        opacity: 0;
        display: none;
      }

      .saleService_phone:hover {

        .saleService_pop_phone {
          opacity: 1;
          display: block;
        }

      }

      .saleService_wx:hover {

        .saleService_pop_wx {
          opacity: 1;
          display: block;
        }

      }

  }




  .login {
    display: flex;
    height: 100%;
    min-width: 1366px;
    position: relative;
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 64%;
    height: 100%;
    background-repeat: no-repeat;
    /*background: url(~@/assets/images/login_bg.png) no-repeat;*/
    background-size: 100% 100%;
    position: relative;

    .text {
      font-size: 50px;
      color: #fff;
      line-height: 1;
    }
  }

  .right {
    display: flex;
    width: 36%;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    /*padding-top: 184px;*/
    padding-bottom: 8px;

    .right-prompt{
      padding-top: 16px;
      padding-right: 8px;
      padding-left: 8px;
    }

    .header {
      width: 240px;
      height: 240px;
      margin: 100px auto 5px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .body {
      width: 100%;
      min-width: 288px;
      max-width: 424px;
      padding-bottom: 48px;
    }

    .footer {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.25);
      text-align: center;
    }
  }

  /deep/ .ant-divider-inner-text a {
    color: #3a7fbc;
  }
</style>
